import { Typography } from '@arionbanki/arionui';
import { LegendPie } from 'components';

type RiskQLegendProps = Readonly<{
	className: string;
	firstDescrption: string;
	secondDescription: string;
}>;

export function RiskQLegend(props: RiskQLegendProps) {
	const { className, firstDescrption, secondDescription } = props;
	return (
		<Typography className={className} TagName="p">
			<LegendPie color="#B79776" />
			&nbsp; {firstDescrption} &nbsp;&nbsp;&nbsp;
			<LegendPie color="#0B45E6" />
			&nbsp; {secondDescription}
		</Typography>
	);
}
